import { render } from "./ReservationOrders.vue?vue&type=template&id=5cf0a002"
import script from "./ReservationOrders.vue?vue&type=script&lang=js"
export * from "./ReservationOrders.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__